interface DataProps {
    date : any;
    performance : number;
    benchmark : number;
}

function BaseDataInterpolator() {
}

interface BaseDataInterpolator {
    interpolateFunction( data : Array<DataProps> ) : Array<DataProps>;
}

BaseDataInterpolator.prototype.interpolate = function( data ) {
    const copy = [];

    for ( let index = 0; index < data.length - 1; ++index ) {
        copy.push( data[index] );
        if ( this._passesThreshold( data[index], data[index + 1] ) ) {
            const additionalData = this._internalInterpolate( data[index], data[index + 1] );
            if ( additionalData ) {
                copy.push( additionalData );
            }
        }
    }
    copy.push( data[data.length - 1] );

    return copy;
};

BaseDataInterpolator.prototype._passesThreshold = function( first, second ) {
    throw new Error( 'The DataInterpolator does not implement the function _passesThreshold' );
};

BaseDataInterpolator.prototype._internalInterpolate = function( first, second ) {
    throw new Error( 'The DataInterpolator does not implement the function _internalInterpolate' );
};

export default BaseDataInterpolator;